export default "__VITE_ASSET__D2AMI5TH__"